<template>
  <nav class="navbar navbar-expand-lg navbar-light fixed-top" id="topnav">
    <div class="container">
      <router-link to="/" class="navbar-brand">
        <img src="/assets/img/logo.png" alt="Evdeki Öğretmen" class="navbar-brand-img">
      </router-link>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbar" aria-controls="navbar" aria-expanded="false" aria-label="Navigasyonu aç">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbar">
        <ul class="navbar-nav mr-auto">
          <li class="nav-item">
            <router-link exact :to="{ name: 'Home' }" class="nav-link">
              <i class="fe fe-home"></i> Ana sayfa
            </router-link>
          </li>
          <li class="nav-item">
            <router-link :to="{ name: 'HomeWork' }" class="nav-link" :class="this.$store.state.app.home_work ? '' : 'disabled'">
              <i class="fe fe-edit-2"></i> Online Sınav <sup class="badge badge-danger" v-if="!this.$store.state.app.home_work">Yakında</sup>
            </router-link>
          </li>
        </ul>
      </div>
      <div class="navbar-user">
        <span v-if="t" ref="timer" class="timer" :class="timerClass(m)">{{ m }}<span class="timer-indicator">:</span>{{ s }}</span>
        <a href="javascript:;" v-on:click="logOut()" class="dropdown-item"><i class="fe fe-log-out"></i> Çıkış Yap</a>
      </div>
    </div>
  </nav>
</template>
<script>
import base from '@/mixins/base';
export default {
  name: 'TopNav',
  mixins: [base],
  props: {
    t: { type: Boolean, required: false, default: false },
    m: { required: false, default: '40' },
    s: { required: false, default: '00' }
  },
  data() {
    return {
      timer: false
    }
  },
  methods: {
    logOut() {
      this.authClean()
    },
    timerClass(time) {
      time = Number(time);
      if (time < 5) {
        return 'bg-danger'
      } else if (time < 15) {
        return 'bg-warning'
      } else {
        return 'bg-primary'
      }
    }
  },
  created() {
    this.timer = this.t;
  }
}
</script>
<style scoped>
.navbar-brand img {
  filter: invert(1);
}

.timer {
  padding: 2px 5px;
  color: #fff;
  font-weight: 900;
  border-radius: 7px;
  user-select: none
}

.timer-indicator {
  animation: opacity 1s;
  animation-iteration-count: infinite;
}

@keyframes opacity {
  0% {
  opacity: 0;
  }
  50% {
  opacity: 1;
  }
  100% {
  opacity: 0;
  }
}
</style>